import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <p className="text-center text-sm text-gray-200">{t('footer.tagline')}</p>
        <p className="mt-4 text-center text-xs text-gray-400 leading-relaxed max-w-3xl mx-auto">
          {t('footer.disclaimerSummary')}
        </p>
        <nav className="mt-6 flex flex-wrap justify-center gap-6 text-sm">
          <span className="text-gray-400">{t('footer.legal')}</span>
          <Link to="/terms" className="text-gray-200 hover:text-white underline">
            {t('footer.terms')}
          </Link>
          <Link to="/disclaimer" className="text-gray-200 hover:text-white underline">
            {t('footer.disclaimer')}
          </Link>
          <Link to="/safety" className="text-gray-200 hover:text-white underline">
            {t('footer.safety')}
          </Link>
          <Link to="/privacy" className="text-gray-200 hover:text-white underline">
            {t('footer.privacy')}
          </Link>
        </nav>
        <p className="mt-6 text-center text-gray-400 text-sm">
          &copy; {new Date().getFullYear()} MassUniHub. {t('footer.rights')}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
